<script>
export default {
  props: {
    component: Object,
    handler: Object,
  },
  data() {
    return {
      modalShow: false,
      pending: false,
      itemToDelete: null,
    };
  },
  methods: {
    areYouSure: async function () {
      this.modalShow = true;
    },
    yesIAm: async function () {
      this.pending = true;
      await this.handler.action(this.itemToDelete, "delete");
      this.pending = false;
      this.modalShow = false;
      this.itemToDelete = null;
    },
  },
  mounted() {},
};
</script>

<template>
  <div class="stepin-list">
    <div class="stepin-list-modal">
      <f-modal-base
        closable
        v-if="modalShow"
        @close="modalShow = false"
        :pending="pending"
      >
        <template #title2>Remove Remote Speaker ?</template>
        <template #content>
          <f-hint type="negative"
            ><template #message>
              The link will be disabled. This action cannot be undone.
            </template></f-hint
          >
        </template>
        <template #actions>
          <f-button type="tertiary" @click="modalShow = false">No</f-button>
          <f-button type="negative" @click="yesIAm()">Yes</f-button>
        </template>
      </f-modal-base>
    </div>
    <div class="stepin-list-title">{{ component.title }}</div>
    <div class="stepin-list-items">
      <f-sexy-scroll>
        <div
          class="stepin-list-item"
          v-for="item in component.items"
          :key="item['#id']"
        >
          <f-icon icon="fa6-user"></f-icon>
          <div class="item-label">{{ item.title }}</div>
          <f-status :state="item.enabled ? 'positive' : 'negative'"></f-status>
          <f-button
            type="icon transparent small"
            @click="
              itemToDelete = item;
              areYouSure(item);
            "
            ><f-icon icon="fa6-circle-xmark"></f-icon
          ></f-button>
        </div>
      </f-sexy-scroll>
    </div>
  </div>
</template>

<style lang="scss">
.stepin-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  .stepin-list-title {
    color: var(--black, #181919);
    font-size: 12px;
    font-family: Lato;
    font-weight: 600;
  }

  .stepin-list-items {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--grey-100, #dfe5e5);
    border-radius: 0 0 8px 8px;
    height: 200px;
    .stepin-list-item {
      display: flex;
      align-items: center;
      padding: 8px;
      .f-icon {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .item-label {
        flex: 1 1 auto;
        color: var(--black, #181919);
        /* Navigation/Item/Font-size 100/Default */
        font-size: 14px;
        font-family: Lato;
        font-weight: 500;
      }
    }
  }
}
.dark-mode {
  .stepin-list-title {
    color: var(--white-a75);
  }

  .stepin-list-items {
    border: 1px solid var(--white-a10);
    border-radius: 6px;
    .stepin-list-item {
      color: var(--white-a75);
      .f-icon {
      }
      .item-label {
        color: var(--white-a75);
      }
    }
  }
}
</style>